import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@netapp/bxp-design-system-react";
import { BulletIcon } from "@netapp/bxp-style/react-icons/General";
import "../detail.scss";

const AffectedProducts = ({ advisoryData, loading }) => {
  const { t } = useTranslation();

  const affectedList = advisoryData ? advisoryData.kb_affected_list || [] : [];
  const investigatingList = advisoryData
    ? advisoryData.kb_investigating_list || []
    : [];
  const unaffectedList = advisoryData
    ? advisoryData.kb_unaffected_list || []
    : [];

  const renderSection = (list, loadingMessage, noneText) => {
    if (loading) {
      return <Text className="padded-text">{loadingMessage}</Text>;
    }
    if (!loading && list.length === 0) {
      return <Text className="padded-text">{noneText}</Text>;
    }
    return list.map((product, index) => (
      <Text key={index} className="padded-text">
        <BulletIcon style={{ marginRight: "4px", verticalAlign: "middle" }} />
        {product}
      </Text>
    ));
  };

  const disclaimerText = t("advisory_single_disclaimer.other").replace('YEAR', new Date().getFullYear());


  return (
    <div className="overview-content">
      <h2>{t("advisory_single_section_affectedProducts.other")}</h2>
      <div>
        {renderSection(affectedList, "Loading affected products...", "None")}
      </div>
      <h2>{t("advisory_single_section_underInvestigation.other")}</h2>
      <div>
        {renderSection(
          investigatingList,
          "Loading products under investigation...",
          "None"
        )}
      </div>
      <h2>{t("advisory_single_section_unaffected.other")}</h2>
      <div>
        {renderSection(
          unaffectedList,
          "Loading unaffected products...",
          "None"
        )}
      </div>
      <div className="advisory-note">
        {/* <p>{t("advisory_single_disclaimer.other")}</p> */}
        <p>{disclaimerText}</p>
      </div>
    </div>
  );
};

export default AffectedProducts;
